import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AppShell from './components/AppShell';
import { StateProvider } from './components/StateProvider';
import { RecipeProvider } from './components/RecipeProvider';
import Toast from './components/Toast';
import AuthGate from './components/AuthGate';
import Today from './pages/Today';
import Week from './pages/Week';
import Shop from './pages/Shop';
import Kitchen from './pages/Kitchen';
import Household from './pages/Household';
import Recipes from './pages/Recipes';
import Cooking from './pages/Cooking';
import SharedRecipe from './pages/SharedRecipe';
import Login from './pages/Login';
import Onboarding from './pages/Onboarding';
import './styles/global.css';
import './styles/location.css';
import './styles/cooking.css';
import './styles/relaxed.css';
import './styles/pricecatcher.css';
import './styles/recipes.css';
import './styles/accessibility.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StateProvider>
      <RecipeProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/share/:token" element={<SharedRecipe />} />
            <Route path="/onboarding" element={<AuthGate requireHousehold={false}><Onboarding /></AuthGate>} />
            <Route element={<AuthGate><AppShell /></AuthGate>}>
              <Route index element={<Today />} />
              <Route path="week" element={<Week />} />
              <Route path="shop" element={<Shop />} />
              <Route path="kitchen" element={<Kitchen />} />
              <Route path="recipes" element={<Recipes />} />
              <Route path="household" element={<Household />} />
              <Route path="cook/:mealId" element={<Cooking />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toast />
        </BrowserRouter>
      </RecipeProvider>
    </StateProvider>
  </React.StrictMode>
);